const ru = {
    //login
    greeting: "Если ты тратишь больше, чем зарабатываешь, ты всегда будешь бедным.",
    username: "Имя пользователя:",
    registration: "РЕГИСТРАЦИЯ",
    log_required: "обязательно для заполнения",
    pass: "Пароль:",
    in: "ВОЙТИ",
    //registration
    required: "обязательно для заполнения",
    bevare_name_length: "Имя пользователя должно содержать не менее 4 символов.",
    bevare_name_matches: "Имя пользователя может содержать только латинские буквы и цифры.",
    bevare_pass_length: "Пароль не должен быть меньше 4х символов.",
    bevare_pass_matches: "Пароль может содержать только латинские буквы и цифры.",
    bevare_pass_check: "Пароли не совпадают.",
    reg_pass: "Пароль:",
    reg_to_log: "ВХОД",
    check_pass: "Повторите пароль:",
    reg_button: "ЗАРЕГИСТРИРОВАТСЯ",
    reg_username: "Имя пользователя:",
    //logined
    logined_trans_button_text: "Добавить",
    logined_trans_list: "СПИСОК ТРАНЗАКЦИЙ:",
    //navbar
    new_transaction: "новая транзакция",
    transaction_statistic: "статистика транзакций",
    transaction_history: "история транзакций",
    calc: "калькулятор",
    //transaction
    transaction_date: "Дата:",
    transaction_amount: "Сумма:",
    transaction__details: "Расшифровка:",
    //transaction form
    tf_data: "Дата:",
    tf_type: "Тип:",
    tf_expence: "Расход",
    tf_income: "Доход",
    tf_placeholder_target: "Цель траты",
    tf_placeholder_amount: "Сумма",
    tf_error: "К сожалению действие не удалось, попробуйте позже.",
    tf_complite: "Запись добавлена",
    //edit transaction
    et_update: "обновить",
    et_cancel: "отмена",
    //delete transaction
    dt_delete: "Вы желаете удалить запись?",
    dt_error: "К сожалению удаление не удалось, попробуйте позже.",
    dt_complite: "Запись удалена",
    //transaction controls
    tr_contrl_oldbegin: "Сначала старые",
    tr_contrl_newbegin: "Сначала новые",
    tr_contrl_reload: "Обновить данные",
    tr_contrl_find: "Искомый тип транзакции",
    //summary
    sum_total_income: "Всего доход:",
    sum_total_expence: "Всего расход:",
    sum_total_remain: " Остаток:",
    sum_search_in_budget: "Поиск по тратам:",
    sum_search: "Поиск",
    sum_summary_expenses_bytype: "Общие затраты по типам:",
    expence_by_month: "Расходы по месяцам",
};

export default ru;